import React from 'react'
import { isEmpty, isNull, isObject, isUndefined } from 'lodash'

const StatusWrapper = (WrappedComponent) => (props) => {
  const {
    data,
    isError = false,
    isLoading = false,
    isDataEmpty = false
  } = props

  return (
    <WrappedComponent
      {...props}
      isError={isNull(data) || isError}
      isLoading={isUndefined(data) || isLoading}
      isDataEmpty={(isObject(data) && isEmpty(data)) || isDataEmpty}
    />
  )
}

export default StatusWrapper
